import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentoId, documentoDelete } from "../../../redux/documentos/documentosAction";
import { format } from "date-fns";
import DetailPDF from "./detailPdf";
export default function DocumentoDetail(){
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id} = useParams();
    const documentoId = useSelector(state => state.documentos.documentoId);
    const [verPDF, setVerPDF] = useState(false);
    const [borrar, setBorrar] = useState(false);

    useEffect(() => {
        dispatch(getDocumentoId(id));        
    }, [dispatch]);
    console.log(documentoId);

    const handleDelete = () => {
        dispatch(documentoDelete(id))
        setTimeout(() => {
            navigate("/informesDocumentos")
        }, "300");
    }

    const handleModificar = () => {
        navigate(`/documentoModificacion/${id}`)
    }
    
    return(
        <>
            <div className="bg-custom container-custom">
                <div className="container md:m-8 text-orange-500 text-[10pt] font-bold">
                    <div className="mb-4 flex flex-col md:flex-row">
                        <button onClick={()=> setVerPDF(true)} className="w-[200px] text-slate-200 bg-slate-500 hover:text-black">Ver PDF Reparto</button>
                        <button onClick={handleModificar} className="w-[200px] my-1 md:my-0 md:ml-3 text-slate-200 bg-slate-500 hover:text-black">Modificar</button>
                        <button onClick={() => setBorrar(true)} className="w-[200px] md:ml-3 text-slate-200 bg-slate-500 hover:text-black">Borrar Documento</button>
                    </div>
                 <div className="flex flex-col mb-5 md:flex-row">
                    <div className="flex w-[250px]">
                    <p>Documento N°:</p><p className="ml-2">{documentoId.numDocumento}</p>
                    </div>
                    <div className="flex w-[250px]">
                    <p>Estado:</p><p className="ml-2">{documentoId.entregado === true ? "Entregado" : (documentoId.entregado === false && documentoId.armado === true ? "Armado - No Entregado" : "No armado" ) }</p>
                    </div>
                    <div className="flex w-[250px]">
                        <p>Fecha: {documentoId.createdAt && format(new Date(documentoId.createdAt), 'dd/MM/yyyy')}</p>
                    </div>
                 </div>
                <div className="flex flex-col mb-2 border-b md:flex-row md:w-[1150px] border-slate-500">
                    <div className="flex w-[150px]">
                        <p>Cliente N°:</p>
                        <p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.numCliente : "XD"}</p>
                    </div>
                    <div className="flex w-[500px] "><p className="md:ml-2">Nombre:</p>
                        <p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.nombre : documentoId.cliente && documentoId.cliente.nombre}</p>
                    </div>
                    <div className="flex w-[250px]">
                        <p className="md:ml-2">Cuit / Cuil /Dni:</p>
                        <p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.cuitCuilDni : documentoId.cliente && documentoId.cliente.cuitCuilDni}</p>
                    </div>
                </div>
                <div className="flex flex-col w-[1150px] mb-2 border-b md:flex-row border-slate-500">
                    <div className="w-[350px] flex"><p>Ciudad:</p><p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.ciudad : documentoId.cliente && documentoId.cliente.ciudad}</p></div>
                    <div className="w-[500px] flex"><p className="md:ml-2">Direccion:</p><p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.direccion : documentoId.cliente && documentoId.cliente.direccion}</p></div>
                    <div className="w-[100px] flex"><p className="md:ml-2">C.P:</p><p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.cp : documentoId.cliente && documentoId.cliente.cp}</p></div>
                    <div className="w-[100px] flex"><p className="md:ml-2">Zona:</p><p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.zona : documentoId.cliente && documentoId.cliente.zona}</p></div>
                </div>
                <div className="flex flex-col w-[1150px] border-b md:flex-row border-slate-500">
                    <div className="w-[350px] flex"><p>Telefono:</p><p>{documentoId.clienteId ? documentoId.clienteId.telefono : documentoId.cliente && documentoId.cliente.telefono}</p></div>
                    <div className="w-[700px] flex"><p className="md:ml-2">Notas:</p><p className="ml-2">{documentoId.clienteId ? documentoId.clienteId.notas : documentoId.cliente && documentoId.cliente.notas}</p></div>
                </div>
                <div className="w-[1150px] mt-5">
                    <table>
                        <thead>
                            <tr className=" border-y border-slate-200">
                                <td className="w-[60px] text-center border md:w-[80px]">Cod. Art</td>
                                <td className="w-[230px] border md:pl-1 md:w-[598px]">Articulo</td>
                                <td className="w-[150px] hidden md:justify-center md:flex">Ciclo</td>
                                <td className="w-[65px] text-center border md:w-[80px]">Cantidad</td>
                                <td className="w-[55px] text-center border md:w-[80px]">Precio</td>
                                <td className="w-[160px] hidden md:justify-center border-r md:flex">ISBN</td>
                            </tr>
                        </thead>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                {documentoId.articulos && documentoId.articulos.map(e=> {
                                    return(
                                        <tr className="border-b border-slate-600">
                                            <td className="w-[60px] text-center md:w-[80px]">{e.codArticulo}</td>
                                            <td className="w-[230px] truncate md:pl-1 md:w-[598px]">{e.nombre}</td>
                                            <td className="w-[150px] hidden md:justify-center md:flex">{e.ciclo}</td>
                                            <td className="w-[65px] text-right pr-2 md:w-[80px]">{e.cantidad}</td>
                                            <td className="w-[55px] text-right pr-1 md:w-[80px]">{e.precio}</td>
                                            <td className="w-[160px] hidden md:justify-center md:flex">{e.isbn}</td>
                                        </tr>
                                    )
                                })}
                            </tr>
                        </tbody>
                    </table>
                    <div className="mt-5">
                        <div className="flex mb-2">
                            <p>Cantidad de Articulos:</p>    
                            <p className="ml-4">{documentoId && documentoId.totalArt}</p>
                        </div>
                        <div className="flex mb-2">
                            <p>SubTotal:</p>
                            <p className="ml-4">{documentoId && documentoId.subtotal}</p>
                        </div>
                        <div className="flex">
                            <p>Total:</p>
                            <p className="ml-4">{documentoId && documentoId.total}</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>

            {/*PDF*/}
            {verPDF ? (
                        <div
                          className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
                          flex flex-col justify-center items-center"
                        >
                          <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                            <button
                              className="text-black font-bold hover:text-white"
                              onClick={() => setVerPDF(false)}
                            >
                              Cerrar
                            </button>
                          </div>
                          <div>
                            <DetailPDF 
                                numDocumento={documentoId.numDocumento}
                                cliente={documentoId.cliente}
                                articulos={documentoId.articulos}
                                entregado={documentoId.entregado}
                                armado={documentoId.armado}
                                totalArt={documentoId.totalArt}
                                subTotal={documentoId.subtotal}
                                total={documentoId.total}
                            />
                          </div>
                        </div>
                      ) : null}
            
            {/*Modales*/}
            {borrar && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="w-[300px] h-[150px] bg-slate-400 p-4 rounded flex flex-col justify-center items-center">
                        <div>¿Desea este documento?</div>
                        <div className="flex">
                            <button className="bg-red-500 mt-2 p-2 rounded hover:bg-red-600 hover:font-semibold" onClick={handleDelete}>Aceptar</button>
                            <button className="bg-blue-500 ml-7 mt-2 p-2 rounded hover:bg-blue-600 hover:font-semibold" onClick={() => setBorrar(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}